exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-list[data-v-2f2d608d]{padding-top:50px;max-width:800px;margin:auto}@media screen and (max-width:650px){.price-list[data-v-2f2d608d]{padding-top:80px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f2d608d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/priceList/Home.vue
// module id = 481
// module chunks = 0